import { Input } from 'src/chakra-components';

const ShippingDate = ({ register, errors, canEditTracking, minDate }) => (
  <div className="row d-flex align-items-center my-2">
    <div className="col-12 col-md-4">
      <p className="fw-bold mb-0">Data de postagem (*)</p>
      {errors.shippingDate && (
        <p className="text-danger">{errors.shippingDate.message}</p>
      )}
    </div>
    <div className="col-12 col-md-8">
      <Input
        type="datetime-local"
        {...register('shippingDate', { required: true })}
        disabled={!canEditTracking}
        min={new Date(minDate).toISOString().slice(0, 16)}
        max={new Date().toISOString().slice(0, 16)}
      />
    </div>
  </div>
);

export default ShippingDate;
